import Swiper, { Pagination, Navigation, Autoplay, Scrollbar, Thumbs, EffectFade } from "swiper";

Swiper.use([Pagination, Navigation, Autoplay, Scrollbar, Thumbs, EffectFade])

let swiperHero = new Swiper(".hero-slider", {
    slidesPerView: 1,
    loop: true,
    mousewheel: true,
    autoplay: {
        delay: 5000,
    },
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
});

let swiperCompany = new Swiper(".slider-company", {
    slidesPerView: 2,
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    mousewheel: true,
    speed: 3000,
    autoplay: {
        delay: 0,
        disableOnInteraction: false
    },
    breakpoints: {
        "1025": {
            slidesPerView: 4.3,
        },
        "768": {
            slidesPerView: 3.5,
        },
    },
});

let swiperTestimonials = new Swiper(".slider-testimonials", {
  //  effect: "fade",
    slidesPerView: 3,
    spaceBetween: 38,
    centeredSlides: true,
    loop: true,
    mousewheel: true,
    // speed: 3000,
    autoplay: {
        delay: 3000,
        disableOnInteraction: true
    },
    breakpoints: {
        "1280": {
            slidesPerView: 3,
        },
        "1024": {
            slidesPerView: 2,
        },
        "320": {
            slidesPerView: 1,
        },
    },
});